/*
 * Datalayer props
 *
 * data-datalayer-position:
 * data-datalayer-link-type: to specify the type of link to use, it can be DATALAYER_LINK_TYPE
 *
 */

export enum DatalayerDataAttributes {
  DATA_DATALAYER_LINK = 'data-datalayer-link',
  DATA_DATALAYER_POSITION = 'data-datalayer-position',
  DATALAYER_HREF = 'data-datalayer-href',
  DATALAYER_LINK_TYPE = 'data-datalayer-link-type',
  DATALAYER_TYPE = 'data-datalayer-type',
}

export enum DatalayerLinkTypes {
  LINK = 'link',
  DOWNLOAD = 'download',
  LINK_TO_SCROLL = 'link_to_scroll',
  CTA = 'cta',
  ICON = 'icon',
}

export enum DataLayerEventNames {
  REACT_PAGE_LOAD = 'react.page_load',
  GTM_EVENT = '^gtm.',
  GTM_EVENT_LOAD = 'gtm.load',
  ONETRUST_EVENT = '^OneTrust',
  OPTANON_EVENT = '^Optanon',
}

export const IMPRESSION_POPUP_EVENT_NAME = 'impression_popup';

export enum DataLayerEvents {
  PAGE_LOAD = 'react-page-loaded',
  DATALAYER_PUSH_EVENT = 'datalayerpush',
  DELAYED_PAGE_VIEW_EVENTS = 'data-layer.delayed_page_view_events',
}

/*
 * List of all track events
 */
export enum DataLayerTrackEvents {
  IMPRESSION_POPUPS = 'trackEvent-impressionPopup',
  PORTAL_PAGE_LOAD_IMPRESSION_POPUPS = 'trackEventPortalPageLoad-impressionPopup',
  EXIT_POPUP = 'trackEvent-exitPopup',
}

/*
 * Content types for popups events
 */
export enum DatalayerPopupContentTypes {
  NEWS_RIBBON = 'newsribbon',
  IMAGE_GALLERY = 'image_gallery',
  STICKY_POPUP = 'sticky_popup',
  DEVICE_DETAIL = 'device_detail',
  FORM = 'form',
  PRIVACY_CONSENT = 'privacy_consent',
}
